import { DRAWER_SCAN_SUBMIT_INTENTS } from '../constants/drawerScanSubmitIntents.const';
import { DRAWER_NAMES } from '../constants/openDrawerNames.const';
import { type DrawerScanSubmitIntent } from '../types/drawerScanSubmit.type';
import { type OpenDrawerName } from '../types/scanContext.type';

/**
 * The step the open drawer offers a scan. The label purchased drawer answers too,
 * with the terminal step: the operator has just printed, so a re-scan of the same
 * shipment is a scan this action owns and deliberately does nothing with, rather
 * than an unresolved scan the handler would report as a failure.
 */
const INTENT_BY_DRAWER_NAME: Partial<Record<OpenDrawerName, DrawerScanSubmitIntent>> = {
  [DRAWER_NAMES.LABEL_PURCHASED_DRAWER]: DRAWER_SCAN_SUBMIT_INTENTS.ALREADY_PURCHASED,
  [DRAWER_NAMES.LABEL_PURCHASING_DRAWER]: DRAWER_SCAN_SUBMIT_INTENTS.BUY_AND_PRINT,
  [DRAWER_NAMES.ORDER_DETAILS]: DRAWER_SCAN_SUBMIT_INTENTS.CHECKOUT,
  [DRAWER_NAMES.SHIPMENT_DETAILS]: DRAWER_SCAN_SUBMIT_INTENTS.PRINT,
};

export const resolveDrawerScanSubmitIntent = (
  drawerName?: OpenDrawerName,
): DrawerScanSubmitIntent | undefined =>
  drawerName ? INTENT_BY_DRAWER_NAME[drawerName] : undefined;
